<div class="panel-wrapper" #SideMenuContainer>
    <div class="tab-wrapper" data-cy="channels-side-menu" [class.show]="showSideMenu">
        <div class="tabs">
            <div
                class="tab"
                data-cy="channels-side-menu-groups-tab"
                [class.focus]="tabState === GROUP_MODE"
                (mousedown)="tabClick(GROUP_MODE); $event.stopPropagation()">
                {{ 'channel.label.groups' | translate }}
            </div>
            <div
                class="tab"
                data-cy="channels-side-menu-categories-tab"
                [class.focus]="tabState === CATEGORY_MODE"
                (mousedown)="tabClick(CATEGORY_MODE); $event.stopPropagation()">
                {{ 'channel.label.categories' | translate }}
            </div>
            <div
                class="tab"
                data-cy="channels-side-menu-alarm-tab"
                [class.focus]="tabState === ALARM_MODE"
                (mousedown)="tabClick(ALARM_MODE); $event.stopPropagation()">
                {{ 'channel.label.alarm' | translate }}
            </div>
            <div class="add-button-wrapper" (click)="addIconClick(); $event.stopPropagation()">
                <span class="material-symbols-outlined add-icon" data-cy="channels-side-menu-plus-icon">add</span>
            </div>
            <!-- Todo: Merge with more-options component -->
            <div class="more-list-wrapper" [class.show]="showAddMenu">
                <div
                    class="more-list"
                    [class.disabled]="!canAddNewGroup()"
                    data-cy="channels-side-menu-plus-menu-new-channel-group"
                    (click)="addMenuGroupClick()">
                    {{ 'channel.more-options.new-group' | translate }}
                </div>
                <div
                    class="more-list"
                    data-cy="channels-side-menu-plus-menu-new-category"
                    (click)="addMenuCategoryClick()">
                    {{ 'channel.more-options.new-category' | translate }}
                </div>
            </div>
        </div>
        <div class="content">
            <div class="scroll-container" *ngIf="tabState === GROUP_MODE">
                <app-channel-panel-group
                    [selectedChannelId]="selectedChannelId"
                    [selectedChannel]="selectedChannel"
                    [canEditSheet]="canEditSheet"></app-channel-panel-group>
            </div>
            <div class="scroll-container" *ngIf="tabState === CATEGORY_MODE">
                <app-channel-panel-category
                    [selectedChannelId]="selectedChannelId"
                    [selectedChannel]="selectedChannel"
                    [canEditSheet]="canEditSheet"></app-channel-panel-category>
            </div>
            <div class="content-alarm-container" *ngIf="tabState === ALARM_MODE">
                <app-channel-panel-alarm
                    [selectedChannelId]="selectedChannelId"
                    [selectedChannel]="selectedChannel"
                    [activeGroup]="activeGroup"
                    [canEditSheet]="canEditSheet"></app-channel-panel-alarm>
            </div>
        </div>
    </div>
    <div
        class="tab-expansion-button-wrapper"
        data-cy="channels-side-menu-min-max-button"
        (click)="expansionButtonClick()">
        <mat-icon class="expansion-icon" [class.hidden]="showSideMenu" svgIcon="keyboard-double-arrow-left"></mat-icon>
        <div class="menu-expansion" [class.show]="showSideMenu">
            <span class="menu-expansion-text">{{ 'channel.side-menu.description' | translate }}</span>
            <mat-icon svgIcon="keyboard-double-arrow-right"></mat-icon>
        </div>
    </div>
</div>
